import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { freight } from "../../lib/freightApi.js";
import { Shell, Button, Field, Note, Quiet, C, errText } from "./ui.jsx";

/**
 * The opt-in page (the schematic's "Setup · opt-in on a phone" board): a driver, dispatcher or
 * recruiter agrees, on their own phone, to calls and to texts from Alfred. Public: no sign-in.
 *
 * ⛔ EVERY WORD ON THIS PAGE IS THE SERVER'S (backend optin.mjs), versioned, and the answer names the
 * version it saw, so what is stored is what the person read. The card's "Alfred texts you once to
 * confirm" is not here: nothing texts yet. The answer looks the same whether or not the number is on
 * anyone's roster.
 */

export function OptInView({ info, error, phone, setPhone, calls, setCalls, texts, setTexts, trap, setTrap, onAgree, busy, msg, done }) {
  if (error) return <Shell settings={false} brandTo={null} width={420}><Quiet>{error}</Quiet></Shell>;
  if (!info) return <Shell settings={false} brandTo={null} width={420}><Quiet>Loading…</Quiet></Shell>;
  const box = { width: 22, height: 22, marginTop: 2, flex: "0 0 auto" };
  return (
    <Shell company={info.carrierName} settings={false} brandTo={null} width={420}>
      <h1 style={{ margin: 0, fontSize: 28, lineHeight: 1.2, fontWeight: 600 }}>Calls and texts from Alfred</h1>
      {done ? (
        <p style={{ margin: 0, fontSize: 17, lineHeight: 1.5 }}>{`Thank you. ${info.carrierName} has your answer.`}</p>
      ) : (
        <>
          <p style={{ margin: 0, fontSize: 17, lineHeight: 1.5 }}>{info.purpose}</p>
          {/* The hidden field: off-screen, skipped by keyboards, and named so no browser or password
              manager fills it (a real yes taken for a bot's is thanked and lost). A person never fills it. */}
          <input name="hp_x7" tabIndex={-1} autoComplete="off" value={trap} onChange={(e) => setTrap(e.target.value)}
            aria-hidden="true" style={{ position: "absolute", left: "-10000px", width: 1, height: 1, opacity: 0 }} />
          <Field id="cell" label="Your cell number" type="tel" value={phone} onChange={setPhone} autoComplete="tel" inputMode="tel" />
          <label htmlFor="ok-calls" style={{ display: "flex", gap: 12, alignItems: "flex-start", fontSize: 16, lineHeight: 1.5 }}>
            <input id="ok-calls" type="checkbox" checked={calls} onChange={(e) => setCalls(e.target.checked)} style={box} />
            <span>{info.callWords}</span>
          </label>
          <label htmlFor="ok-texts" style={{ display: "flex", gap: 12, alignItems: "flex-start", fontSize: 16, lineHeight: 1.5 }}>
            <input id="ok-texts" type="checkbox" checked={texts} onChange={(e) => setTexts(e.target.checked)} style={box} />
            <span>{info.textWords}</span>
          </label>
          <Button disabled={busy || !phone.trim() || (!calls && !texts)} onClick={onAgree} style={{ minHeight: 52, fontSize: 17 }}>Agree</Button>
          <p style={{ margin: 0, fontSize: 15, color: C.muted }}>{info.closing}</p>
        </>
      )}
      <Note msg={msg} />
    </Shell>
  );
}

export default function OptIn() {
  const { token } = useParams();
  const [info, setInfo] = useState(null);
  const [error, setError] = useState(null);
  const [phone, setPhone] = useState("");
  const [calls, setCalls] = useState(false);
  const [texts, setTexts] = useState(false);
  const [trap, setTrap] = useState("");
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState(null);
  const [done, setDone] = useState(false);
  useEffect(() => {
    let alive = true;
    freight.optInPage(token).then((i) => alive && setInfo(i)).catch((e) => alive && setError(e?.status === 404 ? "This link is no longer active." : errText(e)));
    return () => { alive = false; };
  }, [token]);
  const onAgree = async () => {
    setBusy(true); setMsg(null);
    try { await freight.submitOptIn(token, { phone, calls, texts, hp_x7: trap, version: info.version }); setDone(true); }
    catch (e) { setMsg({ ok: false, text: errText(e) }); }
    finally { setBusy(false); }
  };
  return <OptInView info={info} error={error} phone={phone} setPhone={setPhone} calls={calls} setCalls={setCalls} texts={texts} setTexts={setTexts}
    trap={trap} setTrap={setTrap} onAgree={onAgree} busy={busy} msg={msg} done={done} />;
}
